import type { ComunicacaoProcessualItem } from '@/api/client';
import type { EventFormDefaultValues } from '@/components/EventFormDialog';
import { toTitleCaseClasse } from '@/lib/formatters';

/**
 * Defaults para criar um evento de PRAZO a partir de uma comunicação.
 *
 * NÃO inclui data: o sistema não calcula nem sugere a data final do prazo —
 * o advogado a define no próprio formulário do evento. Reusado pela lista
 * (card) e pelo sheet de detalhes para evitar duplicação.
 */
export function buildPrazoEventDefaults(
  com: Pick<ComunicacaoProcessualItem, 'id' | 'nome_classe' | 'numero_processo' | 'processo_id'>,
): EventFormDefaultValues {
  return {
    titulo: `Prazo — ${toTitleCaseClasse(com.nome_classe ?? '') || com.numero_processo || 'Processo'}`,
    tipo: 'prazo',
    processo_id: com.processo_id ?? undefined,
    // Vincula o evento à comunicação — assim a lista/sheet sabem que o prazo já
    // foi cadastrado e exibem a data no lugar do botão.
    comunicacao_id: com.id,
  };
}
